"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import defaultImage from "@/assets/icons/NewHomePage/default-event.png";
export default function CategoryCard({ data }: any) {
  const [imgSrc, setImgSrc] = useState(data?.image || defaultImage);

  useEffect(() => {
    setImgSrc(data?.image || defaultImage);
  }, [data?.image]);

  return (
    <Link
      href={
        data?.is_external == 1 ? data?.external_url : `/category/${data?.slug}`
      }
      target={data?.is_external == 1 ? "_blank" : "_self"}
      className="w-[60px]  sm:w-[160px] flex flex-col justify-center items-center gap-[12px] md:gap-[25px]"
    >
      <div
        className="relative rounded-full w-[60px] h-[60px] sm:w-[160px] sm:h-[160px] overflow-hidden flex items-center justify-center"
        style={{
          boxShadow:
            "inset 2px 2px 0px rgba(209, 211, 212, 0.4), inset -2px -2px 0px rgba(209, 211, 212, 0.4)",
        }}
      >
        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 138 138"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="138"
            height="138"
            rx="69"
            fill="#D1D3D4"
            fillOpacity="0.17"
          />
        </svg>
        <Image
          src={imgSrc}
          width={1000}
          height={1000}
          alt={data?.name || data?.title || "Category"}
          onError={() => setImgSrc(defaultImage)}
          className="relative z-10  w-[80%] h-[80%] md:w-[90%] md:h-[90%] object-cover rounded-full"
        />
      </div>
      <div>
        <h2
          title={data?.title}
          className="text-[15px] md:text-[25px] leading-[16px] md:leading-[32px] text-center font-bold text-[#D1D3D4] 
               cursor-default"
        >
          {data?.title}
        </h2>
      </div>
    </Link>
  );
}
